import { invalidateLocationQueries } from '@/lib/locations/invalidate';
import { toast } from 'sonner';
import { createMutationHook } from '@/hooks/lib/createMutationHook';
import { apiPost, operationsClient } from '@/lib/api';
import { opsProposalEndpoints } from '@/lib/api/endpoints';
import { opsProposalKeys } from '@/lib/queryKeys';
import type { Proposal, CreateProposalDto } from '@/types/proposal';

/**
 * Creates a new proposal via the operations microservice.
 */
export const useCreateProposal = createMutationHook<Proposal, CreateProposalDto>({
  mutationFn: (dto) =>
    apiPost<Proposal, CreateProposalDto>(operationsClient, opsProposalEndpoints.create(), dto),
  onSuccess: (_data, _variables, queryClient) => {
    // A typed service address is saved to the customer as a location on the
    // server, so this save may have created one. See `invalidateLocationQueries`.
    invalidateLocationQueries(
      queryClient,
      (_data as { contactId?: string | null; customer?: { contactId?: string | null } })
        .contactId ?? (_data as { customer?: { contactId?: string | null } }).customer?.contactId,
    );
    void queryClient.invalidateQueries({ queryKey: opsProposalKeys.lists() });
    toast.success('Proposal created');
  },
});
